import { api } from './client';

export interface ProductType {
    id: string;
    parent_id: string | null;
    label: string;
    sort_order: number;
    is_active: boolean;
    children?: ProductType[];
}

interface ProductTypesResponse {
    status: string;
    data: {
        product_types: ProductType[];
    };
}

export interface ProductTypeRequest {
    id: string;
    parent_id?: string | null;
    label: string;
    sort_order?: number;
    is_active?: boolean;
}

export const productTypeService = {
    getTree: async (): Promise<ProductType[]> => {
        const response = await api.get<ProductTypesResponse>('/product-types');
        return response.data.data.product_types;
    },

    getFlat: async (): Promise<ProductType[]> => {
        const response = await api.get<ProductTypesResponse>('/product-types?flat=1');
        return response.data.data.product_types;
    },

    create: async (payload: ProductTypeRequest): Promise<ProductType> => {
        const response = await api.post<{ status: string; data: { product_type: ProductType } }>(
            '/product-types',
            payload,
        );
        return response.data.data.product_type;
    },

    update: async (id: string, payload: Partial<Omit<ProductTypeRequest, 'id'>>): Promise<ProductType> => {
        const response = await api.put<{ status: string; data: { product_type: ProductType } }>(
            `/product-types/${id}`,
            payload,
        );
        return response.data.data.product_type;
    },

    delete: async (id: string): Promise<void> => {
        await api.delete(`/product-types/${id}`);
    },
};

/** Flat list with breadcrumb labels for pickers. */
export const flattenProductTypes = (
    nodes: ProductType[],
    parentLabel = '',
): Array<{ id: string; label: string }> => {
    const rows: Array<{ id: string; label: string }> = [];
    for (const node of nodes) {
        const fullLabel = parentLabel ? `${parentLabel} › ${node.label}` : node.label;
        rows.push({ id: node.id, label: fullLabel });
        if (node.children?.length) {
            rows.push(...flattenProductTypes(node.children, fullLabel));
        }
    }
    return rows;
};
